import { BsFileEarmarkArrowDown } from 'react-icons/bs'

interface Props {
  text: string
  status: 'reporter' | 'complianceOfficer' | 'superAdmin'
  // Defaults to printing the page, which is what the report views want. The
  // superadmin tables pass their own handler to download a CSV instead.
  onClickHandler?: () => void
  disabled?: boolean
}

const ExportButton = ({
  text,
  status,
  onClickHandler,
  disabled = false,
}: Props) => {
  let btnClasses = ''
  switch (status) {
    case 'complianceOfficer':
      btnClasses = 'rounded-10px bg-white border-0 shadow-header'
      break
    case 'reporter':
      btnClasses = 'rounded-5px bg-transparent border-solid border-[1px] border-lightGray'
      break
    case 'superAdmin':
      btnClasses =
        'rounded-lg bg-white border-solid border-[1px] border-borderGray h-[3rem] hover:bg-mainBg transition-colors disabled:opacity-50'
      break
  }

  return (
    <button
      type='button'
      disabled={disabled}
      className={`${btnClasses} flex items-center justify-center gap-[10px] text-lightGray font-medium py-3 px-4 cursor-pointer print:hidden`}
      onClick={onClickHandler ? onClickHandler : () => window.print()}
    >
      <BsFileEarmarkArrowDown className=' text-lightGray text-xl font-medium' />
      {text}
    </button>
  )
}

export default ExportButton
